import React from 'react';
import { Castle, Shield, Crown, Tent } from 'lucide-react';

const CITY_TYPES = [
  { id: 0, name: 'Campamento', icon: Tent, color: '#8B4513' },
  { id: 1, name: 'Pueblo', icon: Castle, color: '#4682B4' },
  { id: 2, name: 'Ciudad', icon: Shield, color: '#DAA520' },
  { id: 3, name: 'Capital', icon: Crown, color: '#FFD700' },
];

const CityPlacer = ({
  cities = [],
  selectedCityId,
  setSelectedCityId
}) => {
  const selectedCity = cities.find(c => c.id === selectedCityId);
  const isPlaced = (city) =>
    city?.id_sector !== null &&
    city?.id_sector !== undefined &&
    city?.coordinate !== null &&
    city?.coordinate !== undefined;

  return (
    <section className="space-y-4">
      <h3 className="text-xs font-bold text-slate-500 uppercase tracking-widest flex items-center gap-2">
        <Castle size={14} /> Ciudades
      </h3>

      <div className="space-y-2">
        <label className="text-xs font-semibold text-slate-400">Seleccionar Ciudad</label>
        <select
          value={selectedCityId || ''}
          onChange={(e) => setSelectedCityId(parseInt(e.target.value, 10) || null)}
          className="w-full bg-slate-900/50 border border-slate-700 rounded-xl p-3 text-white text-sm focus:border-game-primary focus:outline-none"
        >
          <option value="">-- Elegir ciudad --</option>
          {cities.map(city => (
            <option key={city.id} value={city.id} disabled={isPlaced(city)}>
              {city.name}{isPlaced(city) ? ' (ya colocada)' : ''}
            </option>
          ))}
        </select>
      </div>

      {selectedCity && (
        <div className="p-3 bg-slate-900/50 rounded-xl border border-slate-700 space-y-2">
          <p className="text-xs text-slate-400 font-semibold">Ciudad Seleccionada:</p>
          <p className="text-sm text-white font-bold">{selectedCity.name}</p>
          <div className="flex items-center gap-2 text-xs text-slate-500">
            <span>Tipo: {CITY_TYPES.find(t => t.id === selectedCity.city_type)?.name || 'N/A'}</span>
            <span>•</span>
            <span>Clan: {Number(selectedCity.clan) === 0 ? 'Neutral' : `#${selectedCity.clan}`}</span>
          </div>
          <p className="text-xs text-slate-500">Coordenada: {selectedCity.coordinate ?? 'Sin asignar'}</p>
        </div>
      )}

      <div className="p-3 bg-blue-500/5 rounded-xl border border-blue-500/20">
        <p className="text-[10px] text-blue-400">
          Solo se pueden colocar ciudades que aun no tengan sector y coordenada.
        </p>
      </div>
    </section>
  );
};

export default CityPlacer;
